module.exports = __webpack_public_path__ + "static/media/quality-01.ef27bfda.jpg";